module.exports = __webpack_public_path__ + "img/china1.9cef8924.jpg";